<!-- vue3模版代码 -->
<template>
  <div class="img-panel-wrapper" v-if="props.isShow && currentImg">
    <div class="img-info-box flex-display flex-justify-start flex-align-center" >
        <div class="preview-box"  v-if="currentImg">
          <!-- 视频 -->
          <video v-if="currentImg.object_keys.indexOf('.mp4') !== -1" :src="currentImg.object_keys" style="width:100%;height:100%;" controls></video>
          <!-- 全景图片使用 pannellum -->
          <div v-else-if="isPanorama" ref="pannellumContainer" class="pannellum-container"></div>
          <!-- 普通图片 -->
          <div v-else class="centerP" style="height:100%" :style="restoreNum===3?'left:50%;top:50%':''">
            <div class="drag-title" style="height:100%">
              <img :src="currentImg.object_keys"  :style="{transform:'scale('+scaleNum+')',height:'100%'}" alt="">
            </div>
          </div>
          <div class="preview-btn" @click="handlePreview">
            <LeftCircleFilled style="font-size: 48px;color:#ffffff"/>
          </div>
          <div class="next-btn"  @click="handleNext">
            <RightCircleFilled style="font-size: 48px;color:#ffffff"/>
          </div>
        </div>
        <div class="img-preview-info-box" v-if="currentImg">
          <div v-if="props.type === 'media'">
            <span class="f16 cf">详细信息</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">文件名称：</span>
                <span  class="f12 cf ml20">{{currentImg.file_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">任务名称：</span>
                <span  class="f12 cf ml20">{{currentImg.job_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">航线名称：</span>
                <span  class="f12 cf ml20">{{currentImg.fly_line_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">拍摄负载：</span>
                <span  class="f12 cf ml20">{{currentImg.payload}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">拍摄时间：</span>
                <span  class="f12 cf ml20">{{currentImg.create_time}}</span>
              </div>
              <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">文件位置：</span>
                <!-- <img :src="mapPng" style="width: 16px;" alt=""> -->
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <imageMap :key="currentIndex" :mapInfo="currentImg" isNeedFull/>
              </div>
              <template v-if="currentImg.object_keys.indexOf('.mp4') === -1 && currentImg.lat !== '0.0'">
               <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">导航二维码：</span>
               </div>
               <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <div class="photo-item-qr" v-if="qrCodeDataUri">
                   <div class="alarm-info-qr"  style="cursor: pointer;" @click="previewQrCode()">
                     <img :src="qrCodeDataUri" alt="二维码" />
                   </div>
               </div>
               </div>
              </template>
          </div>
          <div v-if="props.type === 'alarm'">
            <span class="f16 cf">告警信息</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">告警名称：</span>
                <span  class="f12 cf ml20">{{currentImg.name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">告警模型：</span>
                <span  class="f12 cf ml20">{{currentImg.modelName}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">告警时间：</span>
                <span  class="f12 cf ml20">{{currentImg.alarmDate}}</span>
              </div>
              <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">文件位置：</span>
                <!-- <img :src="mapPng" style="width: 16px;" alt=""> -->
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <imageMap :key="currentIndex" :mapInfo="currentImg" isNeedFull/>
              </div>
              <template v-if="currentImg.object_keys.indexOf('.mp4') === -1 && currentImg.lat !== '0.0'">
               <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">导航二维码：</span>
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <div class="photo-item-qr" v-if="qrCodeDataUri">
                   <div class="alarm-info-qr"  style="cursor: pointer;" @click="previewQrCode()">
                     <img :src="qrCodeDataUri" alt="二维码" />
                   </div>
               </div>
              </div>
              </template>
          </div>
          <div v-if="props.type === 'point'">
            <span class="f16 cf">指点飞行详情</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">名称：</span>
                <span  class="f12 cf ml20">{{currentImg.name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">文件大小</span>
                <span  class="f12 cf ml20">{{currentImg.size}}M</span>
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== 0">
                <imageMap :key="currentIndex" :mapInfo="currentImg" isNeedFull />
              </div>
              <template v-if="currentImg.object_keys.indexOf('.mp4') === -1 && currentImg.lat !== '0.0'">
               <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">导航二维码：</span>
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <div class="photo-item-qr" v-if="qrCodeDataUri">
                   <div class="alarm-info-qr"  style="cursor: pointer;" @click="previewQrCode()">
                     <img :src="qrCodeDataUri" alt="二维码" />
                   </div>
               </div>
              </div>
              </template>
          </div>
          <div class="close-btn" @click="closeImgPreview">
            <CloseOutlined style="font-size: 24px;color:#ffffff"/>
          </div>
        </div>
    </div>
    <div class="img-list-box flex-display flex-justify-center flex-align-end">
      <div class="list-scroll-box flex-display flex-justify-start flex-align-end">
          <div class="ml10 viewer-list" :class="currentIndex===index?'is-active-img':''"  v-for="(item,index) in imgSrcList"
              :key="item.object_keys" @click="handleImgPreview(index)">
              <div v-if="item.object_keys.indexOf('.mp4') === -1">
                <img  v-img-lazy="item.object_keys"  style="width:96px;height: 54px;border-radius: 8px;" alt="">
              </div>

              <video v-else :src="item.object_keys" style="width:96px;height: 54px;" ></video>
          </div>
      </div>
      <!-- 工具 -->
      <div class="tool-box flex-display flex-justify-center flex-align-center">
        <ZoomInOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="scaleImg('enlarge')"/>
        <ZoomOutOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="scaleImg('narrow')"/>
        <RedoOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="restoreImg()"/>
        <HighlightOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="handleMarkImg()" v-show="isSign"/>
      </div>
    </div>
      <a-image
      :style="{ display: 'none' }"
      :src="previewQrUrl"
      :preview="{ visible: isPreviewQrVisible, onVisibleChange: (v) => { isPreviewQrVisible = v } }"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed, watch, defineComponent, onMounted, onBeforeUnmount, ref, defineProps, defineEmits, nextTick, h } from 'vue'
import QRCode from 'qrcode'
import { wgs84togcj02 } from 'coordtransform'
import { message, Modal } from 'ant-design-vue'
import mapPng from '/@/assets/media/map.png'
import {
  LeftCircleFilled,
  RightCircleFilled,
  CloseOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RedoOutlined,
  HighlightOutlined
} from '@ant-design/icons-vue'
import imageMap from './imageMap.vue'
import { flagMisreportByAlgorithmAlarm, setAlarmStatus } from '/@/api/alarm'
// pannellum 是传统的 JS 库，需要先加载 libpannellum 再加载 pannellum
import 'pannellum/src/js/libpannellum'
import 'pannellum/src/js/pannellum'
import 'pannellum/src/css/pannellum.css'

const emit = defineEmits(['onClose'])
const props = defineProps<{
    info:object,
    list:Array<object>,
    isShow:boolean,
    type:string,
    isSign:boolean,
    currentIndex?:number,
    }>()
// const imgList = ref(props.list)
const currentImg = ref<any>(props.info || null)
const currentIndex = ref(0)
const imgSrcList = ref<any[]>(Array.isArray(props.list) ? [...props.list] : [])
const scaleNum = ref(1)
const restoreNum = ref(1)
watch(() => props.isShow, (newValue, oldValue) => {
  if (newValue) {
    imgSrcList.value = Array.isArray(props.list) ? [...props.list] : []
    if (props.currentIndex !== undefined) {
      currentIndex.value = props.currentIndex
      switchImage(currentIndex.value)
    }
  } else {
    imgSrcList.value = []
    currentImg.value = null
    currentIndex.value = 0
    qrCodeDataUri.value = ''
    isPreviewQrVisible.value = false
    previewQrUrl.value = ''
    destroyPannellum()
    isPanorama.value = false
  }
})
watch(() => props.info, async (newValue, oldValue) => {
  if (!newValue) {
    currentImg.value = null
    qrCodeDataUri.value = ''
    previewQrUrl.value = ''
    destroyPannellum()
    isPanorama.value = false
    return
  }
  currentImg.value = newValue
  // 销毁之前的 pannellum 实例
  destroyPannellum()
  isPanorama.value = false

  // 检查是否为全景图
  if (newValue && newValue.object_keys && newValue.object_keys.indexOf('.mp4') === -1) {
    isPanorama.value = await checkIsPanorama(newValue.object_keys)
    if (isPanorama.value) {
      initPannellum(newValue.object_keys)
    }
  }

  const list = Array.isArray(props.list) ? props.list : []
  list.forEach((item: any, index) => {
    switch (props.type) {
      case 'point':
        if (item.name === newValue.name) {
          currentIndex.value = index
          getQrCode()
        }
        break
      case 'alarm':
        if (item.id === newValue.id) {
          currentIndex.value = index
          getQrCode()
        }
        break
      default:
        if (item.file_name === newValue.file_name) {
          currentIndex.value = index
          getQrCode()
        }
    }
  })
}, {
  deep: true
})

onMounted(() => {
  // pannellum 已通过 import 挂载到 window
  imgSrcList.value = Array.isArray(props.list) ? [...props.list] : []
  if (props.currentIndex !== undefined && imgSrcList.value[props.currentIndex]) {
    currentIndex.value = props.currentIndex
    switchImage(currentIndex.value)
    return
  }
  if (props.info) {
    currentImg.value = props.info
    getQrCode()
  }
})

// pannellum 实例
onBeforeUnmount(() => {
  destroyPannellum()
})

const pannellumViewer = ref<any>(null)
const pannellumContainer = ref<HTMLElement | null>(null)

const getPanoramaUrl = (imgUrl: string) => {
  if (!imgUrl) return ''
  const isSignedUrl = imgUrl.includes('X-Amz-Signature=') || imgUrl.includes('X-Amz-Credential=')
  if (isSignedUrl) return imgUrl
  return imgUrl + (imgUrl.includes('?') ? '&' : '?') + '_t=' + Date.now()
}

// 判断是否为全景图片（宽高比接近 2:1）
const isPanorama = ref(false)
const checkIsPanorama = (imgUrl: string) => {
  return new Promise<boolean>((resolve) => {
    const img = new Image()
    img.onload = () => {
      const ratio = img.width / img.height
      // 宽高比在 1.9 - 2.1 之间认为是全景图
      resolve(ratio >= 1.9 && ratio <= 2.1)
    }
    img.onerror = () => resolve(false)
    img.src = imgUrl
  })
}

// 初始化 pannellum
const initPannellum = (imgUrl: string) => {
  nextTick(() => {
    if (pannellumViewer.value) {
      pannellumViewer.value.destroy()
    }
    if (pannellumContainer.value && (window as any).pannellum) {
      pannellumViewer.value = (window as any).pannellum.viewer(pannellumContainer.value, {
        type: 'equirectangular',
        panorama: getPanoramaUrl(imgUrl),
        autoLoad: true,
        showControls: false,
        compass: false,
        crossOrigin: 'anonymous',
      })
    }
  })
}

// 销毁 pannellum
const destroyPannellum = () => {
  if (pannellumViewer.value) {
    pannellumViewer.value.destroy()
    pannellumViewer.value = null
  }
}

// 导航二维码

async function getQrCode () {
  if (!currentImg.value || currentImg.value.lat === '0.0') return
  // 导航二维码
  const wgs84Lng = Number(currentImg.value.lng)
  const wgs84Lat = Number(currentImg.value.lat)
  const gcj02Coords = wgs84togcj02(wgs84Lng, wgs84Lat)

  const qrUrlBase = `https://m.amap.com/share/index/lnglat=${gcj02Coords[0]},${gcj02Coords[1]}&name=${currentImg.value.job_name || currentImg.value.flyJobName}&src=uriapi&innersrc=uriapi`
  qrCodeDataUri.value = ''
  try {
    qrCodeDataUri.value = await QRCode.toDataURL(qrUrlBase, { width: 400, margin: 1 })
  } catch (err) {
    console.error('Failed to generate QR code', err)
  }
}

const qrCodeDataUri = ref('')
const isPreviewQrVisible = ref(false)
const previewQrUrl = ref('')

function previewQrCode () {
  if (!qrCodeDataUri.value) return
  previewQrUrl.value = qrCodeDataUri.value
  isPreviewQrVisible.value = true
}

function handleMarkImg () {
  if (!currentImg.value) return
  Modal.confirm({
    zIndex: 9999,
    title: h('div', { style: 'color:#ffffff;' }, '是否标记该图片误报'),
    onOk () {
      setAlarmStatus({ id: currentImg.value.id, marker_status: 0 }).then(res => {
        if (res.code === 0) {
          message.success('标记成功')
          imgSrcList.value.forEach((el, index) => {
            if (index === currentIndex.value) {
              imgSrcList.value.splice(index, 1)
              if (imgSrcList.value.length > currentIndex.value) {
                currentImg.value = imgSrcList.value[currentIndex.value]
              } else {
                if (imgSrcList.value.length === 0) {
                  emit('onClose', false)
                  return
                }
                currentImg.value = imgSrcList.value[imgSrcList.value.length - 1]
                currentIndex.value = imgSrcList.value.length - 1
              }
            }
          })
        }
      })
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}
function restoreImg () {
  scaleNum.value = 1
  restoreNum.value = 3
}
function scaleImg (type:string) {
  if (type === 'enlarge') {
    if (scaleNum.value > 2) {
      return
    }
    scaleNum.value += 0.2
  } else {
    if (scaleNum.value < 0.8) {
      return
    }
    scaleNum.value -= 0.2
  }
}
async function switchImage (index: number) {
  if (!imgSrcList.value.length || index < 0 || index > imgSrcList.value.length - 1) {
    return
  }
  // 销毁之前的 pannellum 实例
  destroyPannellum()
  isPanorama.value = false

  currentImg.value = imgSrcList.value[index]
  // 检查是否为全景图
  if (currentImg.value && currentImg.value.object_keys && currentImg.value.object_keys.indexOf('.mp4') === -1) {
    isPanorama.value = await checkIsPanorama(currentImg.value.object_keys)
    if (isPanorama.value) {
      initPannellum(currentImg.value.object_keys)
    }
  }

  getQrCode()
}

function handlePreview () {
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value--
  if (currentIndex.value < 0) {
    currentIndex.value = 0
    message.warning({
      content: '已是第一张图片',
      key: 'first_img'
    })
  } else {
    switchImage(currentIndex.value)
  }
}
function handleNext () {
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value++
  if (currentIndex.value > imgSrcList.value.length - 1) {
    currentIndex.value = imgSrcList.value.length - 1
    message.warning({
      content: '已是最后一张图片',
      key: 'last_img'
    })
  } else {
    switchImage(currentIndex.value)
  }
}
function handleImgPreview (index:number) {
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value = index
  switchImage(index)
}
function closeImgPreview () {
  currentImg.value = null
  currentIndex.value = 0
  imgSrcList.value = []
  scaleNum.value = 1
  restoreNum.value = 1
  // 销毁 pannellum 实例
  destroyPannellum()
  emit('onClose', false)
}

</script>
<style scoped>

.map-box{
  width: 100%;
  height: 200px;
}

.pannellum-container {
  width: 100%;
  height: 100%;
}
.img-panel-wrapper{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #1c1c1c;
    z-index: 1022;
}
.img-info-box{
  width: 100%;
  height: calc(100% - 180px);
}
.img-list-box{
  width: 100vw;
  height: 180px;
  border-top: 1px solid #000000;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.tool-box{
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.list-scroll-box{
  width: 70%;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;
  padding-bottom: 10px
}
.preview-box{
  width: 80%;
  height: 100%;
  background-color: #000000;
  position: relative;
  overflow: hidden;
}
.img-preview-info-box{
  width: 20%;
  height: 100%;
  position: relative;
  padding: 20px 30px;
  box-sizing: border-box;
}
.preview-btn{
  user-select: none;
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.next-btn{
  user-select: none;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.viewer-list{
  overflow: hidden;
  box-sizing: border-box;
  -webkit-filter: brightness(60%); /* Chrome, Safari, Opera */
  filter:brightness(60%);
  flex-shrink:0;
}
.is-active-img{
  border: 2px solid #1088f2;
  border-radius: 10px;
  -webkit-filter: brightness(100%); /* Chrome, Safari, Opera */
  filter:brightness(100%)
}
.close-btn{
  position: absolute;
  right: 20px;
  top: 30px;
}
.alarm-info-qr {
      width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }
  .alarm-info-qr img {
        width: 300px;
        height: 300px;
        border-radius: 4px;
        background: #fff;
        padding: 2px;
      }
</style>
